import { Layout } from "antd";
import styled from "styled-components";

export const StyledContent = styled(Layout.Content)`
  margin-left: 240px;
  display: absolute;
  width: 100%-240px;
  height: 93vh;
`;
